enum EmailBounceStatus {
  Valid = 'Valid',
  Invalid = 'Invalid',
  ValidationPending = 'ValidationPending',
  Unknown = 'Unknown',
}

export default EmailBounceStatus;
